<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Club Events</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Requires volunteers</th>
                        <th>Start date</th>
                        <th>End date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(event, index) in events">
                        <td>{{ event.club_event_name }}</td>
                        <td>{{ event.event_type }}</td>
                        <td>{{ event.requires_volunteers ? 'Yes' : 'No' }}</td>
                        <td>{{ formatDate(event.start_date) }}</td>
                        <td>{{ formatDate(event.end_date) }}</td>
                        <td>
                            <a :href="`/events/${event.id}`" class="btn btn-success">Jobs</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        data: function () {
            return {
                events: []
            }
        },

        mounted() {
            this.getClubEvents();
        },

        methods: {
            getClubEvents() {
                axios.get('/api/v1/club_events').then((response) => {
                    this.events = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club events.', type: 'error'});
                });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            }
        },
    }
</script>
